

import React, { useState } from 'react';
import axios from 'axios';
import logo from '../images/logo_text.png';
import TryButton from '../button/TryButton';
import '../../App.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import moment from 'moment';
import DatePicker from "react-datepicker";


export default function TransferLogsPage() {
    const token = window.localStorage.getItem("token");

    const [transferLogs, setTransferLogs] = useState([]);       // [{attendeeDocs, date, fromUser, fromUserId, schedules: {id: {group-time: status}}, toUser, toUserId}]

    const [date, setDate] = useState(new Date());

    return (
        <div className="page no-padding-top">
            <div className="d-flex mx-md-5 py-3 text-md-start justify-content-between ">
                <a href="/">
                    <img src={logo} className="logo-search" alt="Logo" />
                </a>
                <TryButton className='me-3 my-3'
                    onClick={() => window.history.back()}
                    text="Revenire" />
            </div>

            <div className='d-flex justify-content-center'>
                <div className='w-50 mx-md-5 mx-3 py-4'>
                    <DatePicker
                        dateFormat="dd/MM/yyyy"
                        placeholderText="zi/lună/an"
                        className="form-control animate__shakeX"
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        yearDropdownItemNumber={100}
                        onFocus={(e) => e.target.readOnly = true}
                        selected={(date && new Date(date)) || null}
                        onChange={val => {
                            setDate(val);
                            axios.get(process.env.REACT_APP_API_URL + '/auth/transferLogs/' + moment(val).utc(true).format('DD-MM-YYYY'), {
                                headers: {
                                    Authorization: `Bearer ${token}`
                                }
                            }).then((response) => {
                                // Make attendeeDocs accessible by id
                                const attendeeDocsById = {};
                                response.data.forEach(log => {
                                    log.attendeeDocs.forEach(att => {
                                        attendeeDocsById[att._id] = att;
                                    });
                                });

                                response.data.forEach(log => {
                                    log.attendeeDocs = attendeeDocsById;
                                });

                                setTransferLogs(response.data);
                            }).catch((error) => {
                                console.log(error);
                            });
                        }}
                        onYearChange={(date) => setDate(date)}
                        onMonthChange={(date) => setDate(date)}
                        onWeekSelect={(date) => setDate(date)}
                        onDayChange={(date) => setDate(date)}
                        openToDate={date}
                    />
                </div>
            </div>

            <div className='mx-3'>
                {transferLogs.map((log, index) =>
                    <Row key={index} className='w-100 justify-content-center m-0 py-3'>
                        <Col xs={8} md={3} className='border border-2 border-warning'>
                            <p>{moment(log.date).format("DD/MM/yyyy - HH:mm:ss")}</p>
                        </Col>
                        <Col xs={12} md={4} className='border border-2 border-warning'>
                            <p>De la: {log.fromUser.name}</p>
                            <p>Către: {log.toUser.name} </p>
                            {Object.keys(log.schedules).map((attendeeId) =>
                                <>
                                    <p key={attendeeId}>Participant: {log.attendeeDocs[attendeeId].name}</p>

                                    {Object.keys(log.schedules[attendeeId]).map((groupTime) =>
                                        <p key={attendeeId + groupTime}>- {groupTime}: {log.schedules[attendeeId][groupTime]}</p>
                                    )}
                                </>
                            )}
                        </Col>
                    </Row>
                )}
            </div>

        </div>
    )
}